//Boilerplate
import React from "react";
import PropTypes from 'prop-types';

//Our Stuff
import { AppraiserMacCard } from "components/User";
import { MSpinner} from "components/Shared";

class MacList extends React.Component {

  componentDidMount() {
    const {appraiserNumber, getProfile} = this.props;
    if (!appraiserNumber) {
      getProfile();
    }
  }

  render() {
    const {isFetchingProfile, appraiserNumber} = this.props;
    
    if(isFetchingProfile) {
      return <MSpinner/>;
    }

    return (
      <div className="mac-list case-header md-grid no-padding">
        <div className="md-cell md-cell--12 md-cell--right mac-page">
          <AppraiserMacCard
            appraiserNumber = {appraiserNumber} 
            displayFooter
          />
        </div>
      </div>
    );
  }
}

MacList.propTypes = {
  appraiserNumber: PropTypes.number,
  getProfile: PropTypes.func.isRequired,
  isFetchingProfile: PropTypes.bool.isRequired,
  providedAppraiserNumber: PropTypes.number,
  isCardGrid: PropTypes.bool,
};

export default MacList;
